import React from 'react'
import s from './styles/DropdownFilter.module.scss'
import { useDropdownFilter } from './hooks/useDropdownFilter'
import CheckBox from 'shared/ui/CheckBox/CheckBox'

export default function DropdownFilter({
	title,
	subtitle,
	options = [],
	selected = [],
	filterKey,
	onChangeKey,
	searchable = false,
	searchPlaceholder = 'Search',
}) {
	const {
		isOpen,
		isActive,
		selectedLabels,
		visibleOptions,
		searchQuery,
		setSearchQuery,
		toggleOpen,
		toggleValue,
		removeValue,
	} = useDropdownFilter({ options, selected, filterKey, onChangeKey, searchable })

	return (
		<div
			className={`${s.wrap} ${isActive ? s.active : ''} ${
				isOpen ? s.open : ''
			}`}
		>
			<div className={s.head}>
				<button
					type="button"
					className={s.trigger}
					onClick={toggleOpen}
					aria-expanded={isOpen}
				>
					<div className={s.triggerLeft}>
						<div className={s.title}>{title}</div>
						{subtitle && <div className={s.subtitle}>{subtitle}</div>}
					</div>
					<div className={s.chevron} aria-hidden="true" />
				</button>

				{isActive && (
					<div className={s.badges}>
						{selectedLabels.map(item => (
							<button
								key={item.value}
								type="button"
								className={s.badge}
								onClick={e => removeValue(item.value, e)}
							>
								<span className={s.badge__text}>{item.label}</span>
								<span className={s.badge__close} aria-hidden="true">
									×
								</span>
							</button>
						))}
					</div>
				)}
			</div>

			{isOpen && (
				<div className={s.menu}>
					{searchable ? (
						<div className={s.search}>
							<input
								type="search"
								className={s.search__input}
								placeholder={searchPlaceholder}
								value={searchQuery}
								onChange={e => setSearchQuery(e.target.value)}
								onClick={e => e.stopPropagation()}
								aria-label={`Search ${title}`}
							/>
						</div>
					) : null}

					{visibleOptions.length ? (
						visibleOptions.map(opt => {
							const checked = selected.includes(opt.value)
							return (
								<div
									key={opt.value}
									className={`${s.option} ${checked ? s.optionActive : ''}`}
									onClick={() => toggleValue(opt.value)}
								>
									<span className={s.option__inner}>
										<span className={s.option__line}>
											<span className={s.option__text}>{opt.label}</span>
											{typeof opt.count === 'number' && (
												<span className={s.option__count}>{opt.count}</span>
											)}
										</span>
										{opt.hint && (
											<span className={s.option__hint}>{opt.hint}</span>
										)}
										{opt.meta && (
											<span className={s.option__meta}>{opt.meta}</span>
										)}
									</span>
									<CheckBox
										isSelected={checked}
										onToggle={() => toggleValue(opt.value)}
										variant="round"
									/>
								</div>
							)
						})
					) : (
						<div className={s.empty}>No matches</div>
					)}
				</div>
			)}
		</div>
	)
}
